<mat-spinner class="spinner" *ngIf="isLoading"></mat-spinner>
<div [class.blur-background]="isLoading">
  <h2 class="text-center" mat-mdc-dialog-title>Security Check - {{ data.RegNo }}</h2>
  <div mat-dialog-content>


    <div class="row" style="display: flex; justify-content: space-between; align-items: flex-start; overflow-x: hidden;">

      <div [ngStyle]="{'border-right': isBookingSeleceted ? 'solid 1px #c8c8c8' : 'none'}" style="flex:1;" [style.max-width]="isBookingSeleceted ? '50%' : '100%'">
        <button mat-mini-fab (click)="onNoClick()" class="close-icon" color="primary"><mat-icon>close</mat-icon></button>

        <div class="row" style="width: 100%; margin:10px;">
          <div class="col-6" style="overflow: scroll; overflow-x: hidden;">
            <p><b>Bookings</b></p>
            <ng-container *ngIf="processedRentals">
              <!--<div class="row" style="text-align:center">
                <div class="col-6">Booking</div>-->
                <!--<div class="col-4" style="white-space:nowrap">Ai Judgement</div>-->
                <!--<div class="col-6">Date</div>
              </div>-->

              @for (object of processedRentals; track object) {

              <div class="row" [ngClass]="{'highlighted': filteredRentalIssues.has(object.rentalId) || hasAIIssueInfoForRental(object.rentalId), 'highlighted-cancelled': object.rentalStatus == 1, 'highlighted-light': hasAIInfoForRental(object.rentalId)}">
                      <div class="col-6" [ngClass]="{'highlighted-text': filteredRentalIssues.has(object.rentalId) || hasAIIssueInfoForRental(object.rentalId)}">
                        <t4-booking-link (clicked)="updateBookingSelected(object.rentalId)" [preventDefault]="true" [bookingId]="object.rentalId">
                          {{ object.rentalId }}
                        </t4-booking-link>
                        <mat-icon style="transform:scale(0.8);" *ngIf="isBookingWithSpareParts(object.rentalId)" matTooltip="Spare part">label_important</mat-icon>
                      </div>

                <!--<div class="col-2">
                  @if (object.AIJudgement === null) {
                  <mat-icon style="color:lightslategray;" matTooltip="Unable to determine status.">question_mark</mat-icon>
                  }
                  @else if (object.AIJudgement === true) {
                  <mat-icon style="color:red;" matTooltip="Issue detected.">nearby_error</mat-icon>
                  }
                  @else {
                  <mat-icon style="color:green;" matTooltip="No issues found.">check</mat-icon>
                  }
                </div>-->

                <div class="col-6" style="text-align:end;">{{ object.pickupDate | date:'mediumDate' }}</div>
             </div>
              }

            </ng-container>

            <hr />
            <div>
              <p><b>Service</b></p>
              <ng-container *ngIf="objectInfo">
                <ng-container *ngFor="let request of objectInfo.ServiceRequests">
                  <div class="row">
                    <div class="statusIcon" style="float: left; margin: 0px; align-self:center;" [ngClass]="{'status-green': (request.Status == 50 || request.Status == 100), 'status-red': (!request.ExpectedResolveDate || request.ExpectedResolveDate < today), 'status-yellow': (request.ExpectedResolveDate < tomorrow && request.ExpectedResolveDate >= today) }"></div>
                    <div class="col-5 hover-item" (click)="serviceRequestClicked(request)">{{ request.RequestNo }}</div>
                    <div class="col-6" style="text-align:end;">{{ request.CreatedAt | date:'mediumDate' }}</div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="col" style="border-left: solid 1px #c8c8c8; overflow:scroll;">

            <mat-form-field style="width:100%;">
              <mat-label>Sort on Issues</mat-label>
              <mat-select [formControl]="groupsControl" multiple (selectionChange)="applyFilter()">
                <mat-option *ngFor="let category of issueCategories" [value]="category">{{category}}</mat-option>
              </mat-select>
            </mat-form-field>

            <div class="row">
              <div class="col-5"><b>Amount: </b>{{ amount }}</div>
              <div class="col-3 text-center"><mat-icon class="red-icon">close</mat-icon></div>
            </div>
            <ng-container *ngFor="let entry of counters | keyvalue">
              <div class="row">
                <div class="col-5">{{ entry.key }}</div>
                <div class="col-3 text-center">{{ entry.value }}</div>
              </div>
            </ng-container>

            @if(aiInformations){
            <div class="title-with-divider">
              <div class="title">AI Comment</div>
            </div>

            <ng-container *ngFor="let aiInfo of aiInformations; let i = index; let last = last">
              <div class="row">
                <div class="col">

                  <strong><t4-booking-link (clicked)="updateBookingSelected(aiInfo.rentalId)" [preventDefault]="true" [bookingId]="aiInfo.rentalId">{{ aiInfo.rentalId }}</t4-booking-link></strong>
                  @if(aiInfo.comment || aiInfo.uncertantyComment){
                  <button mat-icon-button style="margin-left:10px;" (click)="openServiceDialogComment((aiInfo.comment ?? '') + '. ' +  (aiInfo.uncertantyComment ?? ''))">
                    <mat-icon>post_add</mat-icon>
                  </button>
                  }

                  <div *ngIf="aiInfo.comment">
                    <strong>Comment:</strong>
                    {{ aiInfo.comment}}
                  </div>

                  <div *ngIf="aiInfo.shouldbeDisabled">
                    <strong>Should be Disabled:</strong>
                    {{ aiInfo.shouldbeDisabled}}
                    <br />
                    <strong>Reason:</strong>
                    {{ aiInfo.disableComment }}
                  </div>

                  <!--<div *ngIf="aiInfo.uncertantyComment">
                    <strong>Uncertainty:</strong>
                    {{ aiInfo.uncertantyComment}}
                  </div>-->

                </div>
              </div>
              <hr *ngIf="!last" />
            </ng-container>
            }
            <div class="title-with-divider">
              <div class="title">Comment</div>
            </div>
            <ng-container *ngIf="filteredRentals">
              <ng-container *ngFor="let rental of filteredRentals">
                <div *ngFor="let remark of rental.remarks">
                  <div class="row">
                    <div class="col">
                      <p>{{ remark.date | date:'medium'}}</p>
                    </div>
                    <div class="col" style="text-align:end;">
                      <t4-booking-link (clicked)="updateBookingSelected(rental.rentalId)" [preventDefault]="true" [bookingId]="rental.rentalId">{{ rental.rentalId }}</t4-booking-link>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <p>{{ remark.comment }}</p>
                    </div>
                    <div class="col-3" style="align-self: center; text-align: center;">
                      <button mat-flat-button (click)="openServiceDialogComment(remark.comment)">
                        <mat-icon>post_add</mat-icon>
                      </button>
                    </div>
                  </div>
                  <hr />
                </div>
              </ng-container>
            </ng-container>

          </div>
        </div>
      </div>

      <div *ngIf="isBookingSeleceted" style="flex:1; max-width:50%;">
        <h4 style="text-align:center;">Booking - <t4-booking-link [bookingId]="bookingSelected">{{ bookingSelected }}</t4-booking-link></h4>
        <dialog-rentaldialog *ngIf="bookingSelected" [(bookingInput)]="bookingSelected"></dialog-rentaldialog>
      </div>
    </div>
  </div>
  <div mat-dialog-actions style="border-top: solid 1px #c8c8c8; justify-content: space-between; padding-right:20px; padding-left:20px;">
    <button align="center" mat-flat-button color="primary" (click)="openServiceDialog()" class="save-btn">Create Service Request</button>

    <button mat-flat-button (click)="markAsServiceGuy(); markAsCustomerSupport(); setAIQueueItems(1); closeDialog()"><mat-icon>delete</mat-icon>Remove (No Issues)</button>
    <button mat-flat-button (click)="markAsServiceGuy(); markAsCustomerSupport(); setAIQueueItems(2); closeDialog()"><mat-icon>delete</mat-icon>Remove (Issues Found)</button>

    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>menu</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="markAsServiceGuy()" [disabled]="data.HandledSG">
        <mat-icon>hide_image</mat-icon>
        <span>Hide for Service guy</span>
      </button>
      <button mat-menu-item (click)="markAsCustomerSupport()" [disabled]="data.HandledCS">
        <mat-icon>done</mat-icon>
        <span>Mark as Completed</span>
      </button>
    </mat-menu>
  </div>
</div>
